// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TerceraCheckBoxTemplate from '@front/templates/TerceraCheckBoxTemplate.html';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { Control } from './Control';
export class TerceraCheckBox extends Control {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.TerceraCheckBox;
    }
    oninit() {
        super.oninit();
        this.observe('checked', this.onCheckedChanged);
        this.observe('checkBoxCheckedState', this.onCheckBoxCheckedStateChanged);
    }
    onCheckedChanged(checked) {
        void this.set('checkBoxCheckedState', checked ? CheckBoxCheckedStates.Checked : CheckBoxCheckedStates.None);
        this.fire(CheckBoxEvents.CheckedStateChange, checked);
    }
    onCheckBoxCheckedStateChanged(state) {
        void this.set('checked', state === CheckBoxCheckedStates.Checked);
    }
    private_CheckBoxClick(sender) {
        if (!this.get('enabled')) {
            return;
        }
        this.fire(CheckBoxEvents.CheckBoxClicked, sender);
        if (this.get('isNeedToogle')) {
            void this.toggle('checked');
        }
    }
}
export var CheckBoxCheckedStates;
(function (CheckBoxCheckedStates) {
    CheckBoxCheckedStates["None"] = "none";
    CheckBoxCheckedStates["Checked"] = "checked";
})(CheckBoxCheckedStates || (CheckBoxCheckedStates = {}));
export var CheckBoxEvents;
(function (CheckBoxEvents) {
    CheckBoxEvents["CheckedStateChange"] = "CheckedStateChange";
    CheckBoxEvents["CheckBoxClicked"] = "CheckBoxClicked";
})(CheckBoxEvents || (CheckBoxEvents = {}));
Control.extendWith(TerceraCheckBox, {
    template: TerceraCheckBoxTemplate,
    data: function () {
        return {
            checked: false, // checked или нет
            checkBoxCheckedState: 'none', // тип checked
            text: '',
            tag: null,
            isNeedToogle: true
        };
    }
});
